import './index.less';
import React, { useEffect, useRef, useState } from 'react';
import { BaseStagePlugin, getStageIndexByMousePointY, useFramework, useIsLongImageMode } from '@/framework';
import { IExportPlugin, PluginType } from '@/version-types';

const StageHover: React.FC = React.memo(() => {
    const framework = useFramework();
    const isLongImageMode = useIsLongImageMode();
    const originIndexRef = useRef<number | null>(null);

    const [_, refresh] = useState(0);

    useEffect(() => {
        if (!isLongImageMode) return;

        let downOriginIndex: number | null = null;

        const mouseDownHandler = framework.events.onMouseDown((e) => {
            downOriginIndex = getStageIndexByMousePointY(framework.identity, e.clientY);
        });

        const mouseUpHandler = framework.events.onMouseUp(() => {
            downOriginIndex = null;
        });

        const mouseEnterHandler = framework.events.onMouseEnter((originIndex, force) => {
            const isBaseOperate = framework.operate.isBaseOperate();
            const isDisablePick = framework.operate.isDisablePick();
            const isMouseSelect = framework.operate.isMouseSelect();
            if (isMouseSelect) {
                originIndexRef.current = downOriginIndex;
                refresh((v) => v + 1);
            } else {
                if (!isBaseOperate && (!isDisablePick || force)) {
                    originIndexRef.current = originIndex;
                    refresh((v) => v + 1);
                }
            }
        });

        const mouseLeaveHandler = framework.events.onMouseLeave(() => {
            const isBaseOperate = framework.operate.isBaseOperate();
            const isDisablePick = framework.operate.isDisablePick();
            const isMouseSelect = framework.operate.isMouseSelect();
            if (isMouseSelect) {
                originIndexRef.current = null;
                refresh((v) => v + 1);
            } else {
                if (!isBaseOperate && !isDisablePick) {
                    originIndexRef.current = null;
                    refresh((v) => v + 1);
                }
            }
        });

        return () => {
            framework.events.off(mouseEnterHandler);
            framework.events.off(mouseLeaveHandler);
            framework.events.off(mouseDownHandler);
            framework.events.off(mouseUpHandler);
        };
    }, [isLongImageMode]);

    if (originIndexRef.current === null || !isLongImageMode) return null;

    return (
        <BaseStagePlugin originIndexOrLayerId={originIndexRef.current} name="stage-hover">
            <div className="c-stage-hover"></div>
        </BaseStagePlugin>
    );
});

const exportPlugin: IExportPlugin = {
    type: PluginType.STAGE,
    sort: -2,
    name: 'stage-hover',
    render() {
        return <StageHover />;
    },
};

export default exportPlugin;
